module.exports = __webpack_public_path__ + "static/media/img26.68180fc3.jpg";